const OpenIDConfigConstants = {
  SET_VISIBLE_RANGE: 'OPENID_SET_VISIBLE_RANGE',
  REFRESH: 'OPENID_REFRESH',
  GET: 'OPENID_GET',
  GET_SUCCESS: 'OPENID_GET_SUCCESS',
  GET_FAIL: 'OPENID_GET_FAIL',
  RELOAD: 'OPENID_RELOAD',
  SET_FILTER: 'OPENID_SET_FILTER',
  ACTIVATE_FILTER: 'OPENID_ACTIVATE_FILTER',
  SET_ADVANCED_FILTER: 'OPENID_SET_ADVANCED_FILTER',
  SET_SORTORDER: 'OPENID_SET_SORTORDER',
  MODIFY_SELECTION: 'OPENID_MODIFY_SELECTION',
  ALLOW_MULTI_SELECT: 'OPENID_ALLOW_MULTI_SELECT',
  REMOVE_SUCCESS: 'OPENID_REMOVE_SUCCESS',
  SAVE_SUCCESS: 'OPENID_SAVE_SUCCESS',
  ENSURE_SELECTION_IS_VISIBLE: 'OPENID_ENSURE_SELECTION_IS_VISIBLE',
  CLEAR: 'OPENID_CLEAR',
  UPDATE: 'OPENID_UPDATE',
  SET_SELECTION: 'OPENID_SET_SELECTION',
  OPEN: 'OPENID_OPEN',
  GET_FOR_OPEN_SUCCESS: 'OPENID_GET_FOR_OPEN_SUCCESS',
  GET_BY_ID_SUCCESS: 'OPENID_GET_BY_ID_SUCCESS',
  FIND_SUCCESS: 'OPENID_FIND_SUCCESS',

  GET_FAILURE: 'OPENID_GET_FAILURE',
  SAVE: 'OPENID_SAVE',
  SAVE_FAIL: 'OPENID_SAVE_FAIL',
  REMOVE: 'OPENID_REMOVE',
  REMOVE_FAIL: 'OPENID_REMOVE_FAIL'
};

export default OpenIDConfigConstants;
